<div
  class="component-container text-cool-grey p-[2.5rem]"
  id="invite_page_container"
>
  <div
    class="role-selection-section  flex items-center justify-center xs:px-[5rem] sm:px-[5rem] md:px-[10rem] lg:px-[18.3rem]">
    <div class="label flex flex-row">Role</div>

    <app-dropdown
      (checkForErrors)="checkForErrors($event)"
      [error]="errorMessages['roles']"
      [options]="rolesOptions"
      [parentFormGroup]="form"
      class="input w-full"
      controlName="role"
      placeholder="Select one"
      type="small"
    />

  </div>
  <hr class="divider"/>
  <div
    *ngIf="selectedRole && selectedRole !== roles.superAdmin"
    class="flex w-full justify-center items-center"
  >
    <div
      class="role-selection-section xs:w-full sm:w-full md:w-[80%] flex md:flex-row items-center justify-center gap-[1.5rem] flex-col"
    >
      <app-search-on-select
        (checkForErrors)="checkForErrors($event)"
        (onNextPage)="clientsOnNextPage()"
        (onPrevPage)="clientsOnPrevPage()"
        *ngIf="userRole === roles.superAdmin"
        [enableClearSelection]="false"
        [error]="errorMessages['client']"
        [hasNext]="clientOptions.hasNext"
        [hasPrev]="clientOptions.hasPrev"
        [loading]="clientOptions.loading"
        [ngClass]="selectedRole === roles.adult || selectedRole ===
        roles.participant ? 'md:w-1/2' : ''"
        [options]="clientOptions.list"
        [parentFormGroup]="form"
        class="input w-full"
        controlName="client"
        filterControlName="searchClient"
        label="Organization"
        optionsPanelClassName="clients-dropdown"
        placeholder="Select a Organization"
        type="small"
      ></app-search-on-select>
      <app-search-on-select
        (checkForErrors)="checkForErrors($event)"
        (onNextPage)="groupNextPage()"
        *ngIf="selectedRole === roles.adult || selectedRole === roles.participant"
        [enableClearSelection]="true"
        [error]="errorMessages['group']"
        [hasNext]="groupOptions?.hasNext"
        [loading]="groupOptions.loading"
        [ngClass]="userRole === roles.superAdmin && (selectedRole ===
        roles.adult || selectedRole === roles.participant) ? 'md:w-1/2' : ''"
        [options]="groupOptions.list"
        [parentFormGroup]="form"
        class="input w-full"
        controlName="group"
        filterControlName="searchGroup"
        label="Group"
        placeholder="Select a Group"
        type="small"
      ></app-search-on-select>
    </div>
  </div>
  <div
    *ngIf="orgSelected"
    class="w-full"
  >
    <!--    Participant Expansion Panel-->
    <mat-expansion-panel
      *ngIf="selectedRole === roles.adult || selectedRole === roles.participant"
      [expanded]="!isExpanded"
      class="mat-elevation-z0 expansion-panel w-full">
      <mat-expansion-panel-header
        class="bg-black-100 flex flex-row justify-center items-center"
      >
        <div class="title text-cool-grey font-poppins font-semibold text-[1.6rem]">
          Participant
        </div>
      </mat-expansion-panel-header>
      <div
        *ngFor="let eachItem of participantConfiguration ; let i = index"
        class="user-detail-container flex flex-col justify-center items-center space-y-[3rem] h-full w-full"
      >
        <div class="w-full">
          <div class="flex justify-end md:w-[75%] w-[90%]">
            <app-toggle-button
              (handleToggle)="toggleButtonClicked($event, eachItem, true)"
              [selectedValue]="eachItem['isNewUser']"
              class="toggle-button flex flex-row w-[85%] md:w-[65%] mt-[2rem]"
              labelFalse="Existing User"
              labelTrue="New User"
            ></app-toggle-button>
          </div>
          <!-- <div class="w-[25%]"></div> -->
        </div>
        <div
          *ngIf="eachItem['isNewParticipant']; else existingUserBlock"
          class="new-user-detail-container w-[90%] md:w-[80%]"
        >
          <app-new-user
            [errorMessageMap]="newUserFormErrorMessageMap"
            [errorMessages]="eachItem['newUserFormErrorMessages']"
            [form]="eachItem['newUserFormGroup']"
            [isParticipant]="true"
            [maxDobDate]="maxDobDate"
            [minDobDate]="minDobDate"
            [uuid]="eachItem.uuid"
          >
          </app-new-user>
        </div>
        <ng-template #existingUserBlock>
          <div class="existing-user-detail-container w-[80%]">
            <app-existing-user
              [clientId]="clientId"
              [errorMessageMap]="existingUserFormErrorMessageMap"
              [errorMessages]="eachItem['existingUserFormErrorMessages']"
              [form]="eachItem['existingUserFormGroup']"
              [isParticipant]="true"
            >
            </app-existing-user>
          </div>
        </ng-template>
      </div>
    </mat-expansion-panel>
    <!--    Other Role Expansion Panel-->
    <mat-expansion-panel
      *ngIf="selectedRole >= roles.superAdmin && selectedRole <= roles.participant"
      [disabled]="!isAdultExpanded"
      [expanded]="isAdultExpanded"
      class="mat-elevation-z0 expansion-panel w-full">
      <mat-expansion-panel-header class="bg-black-100 flex flex-row justify-center items-center">
        <div class="title text-cool-grey font-poppins font-semibold text-[1.6rem]">
          {{ selectedRole === roles['parent'] ? 'Parent' : rolesLabelMap[selectedRole] }}
        </div>
      </mat-expansion-panel-header>
      <div
        *ngFor="let eachItem of configuration; let i = index"
        class="user-detail-container flex flex-col
      justify-center items-center space-y-[3rem]
      h-full"
      >
        <div
          class="action-section flex flex-row w-full mt-[2rem] {{configuration.length >1 ? 'justify-between' : 'justify-center'}} items-center mt-[2rem]">
        <span
          class="md:w-[75%] w-[90%] flex flex-row justify-end items-center"
        >
          <app-toggle-button
            (handleToggle)="toggleButtonClicked($event, eachItem)"
            *ngIf="displayToggleButton"
            [selectedValue]="eachItem['isNewUser']"
            class="toggle-button flex flex-row w-[85%] md:w-[65%] "
            labelFalse="Existing User"
            labelTrue="New User"
          ></app-toggle-button>
        </span>
          <span
            class="md:w-[25%] w-[10%] flex flex-row justify-end items-center mt-[2.rem]"
          >
          <app-icon
            (click)="deleteUser(i)"
            *ngIf="configuration.length >1"
            [svgIcon]="!emailPreviewData ? 'delete' : 'delete-disabled'"
            class="icon cursor-pointer md:mr-[2rem]"
          >
        </app-icon>
        </span>
        </div>
        <div
          *ngIf="eachItem['isNewUser']; else existingUserBlock"
          class="new-user-detail-container w-[80%]">
          <app-new-user
            (larChange)="onLarChanged($event)"
            [errorMessageMap]="newUserFormErrorMessageMap"
            [errorMessages]="eachItem['newUserFormErrorMessages']"
            [form]="eachItem['newUserFormGroup']"
            [index]="i"
            [selectedRole]="selectedRole"
            [uuid]="eachItem.uuid"
          >
          </app-new-user>
        </div>
        <ng-template #existingUserBlock>
          <div class="existing-user-detail-container w-[80%]">
            <app-existing-user
              (larChange)="onLarChanged($event)"
              [clientId]="clientId"
              [errorMessageMap]="existingUserFormErrorMessageMap"
              [errorMessages]="eachItem['existingUserFormErrorMessages']"
              [form]="eachItem['existingUserFormGroup']"
              [index]="i"
            >
            </app-existing-user>
          </div>
        </ng-template>
        <hr
          *ngIf="configuration.length"
          class="w-full text-cool-grey mt-[1.6rem]"
        >
      </div>
      <div
        [class.hidden]="configuration.length >=4"
        class="add-user flex flex-row
                justify-center items-center
                space-x-[1rem] mt-[1rem] mb-[1rem]"
      >
        <app-icon
          (click)="addNewConfiguration()"
          [svgIcon]="!emailPreviewData ? 'add' : 'add-disabled'"
          class="icon cursor-pointer"
        >
        </app-icon>
        <span
          class="text-cool-grey"> Add {{ rolesLabelMap[selectedRole] }}</span>

      </div>
    </mat-expansion-panel>
  </div>
  <div
    *ngIf="selectedRole &&  orgSelected"
    class="action-section flex flex-row w-full justify-end items-end mt-[1.6rem] gap-[2.4rem]"
  >
    <app-primary-button
      (handleClick)="clearFrom()"
      *ngIf="userRole !== roles.superAdmin &&
            !useSystemMailClient"
      [isDisabled]="!userCreated"
      class="preview w-[18rem]"
      type="small"
    >
      Clear Form
    </app-primary-button>
    <app-primary-button
      (handleClick)="submit('preview')"
      *ngIf="userRole === roles.superAdmin ||
            useSystemMailClient"
      [isDisabled]="!isVerifyDisabled || isAutogenerateUsernameLoading ||
      loading"
      [isLoading]="previewLoading"
      class="preview w-[18rem]"
      type="small"
    >
      Preview
    </app-primary-button>
    <app-primary-button
      (handleClick)="preview(true)"
      *ngIf="userRole !== roles.superAdmin &&
            !useSystemMailClient"
      [isDisabled]="!userCreated"
      class="preview w-[18rem]"
      type="small"
    >
      Preview
    </app-primary-button>
    <app-primary-button
      (handleClick)="submit('submit')"
      [isDisabled]="!isVerifyDisabled || isAutogenerateUsernameLoading || previewLoading"
      [isLoading]="loading"
      class="send-invite w-[18rem]"
      type="small"
    >
      <div class="add-user flex flex-row justify-center items-center space-x-[1rem]">
        <app-icon
          [svgIcon]="'send-invite'"
          class="icon small"
        >
        </app-icon>
        <span> {{
            userRole === roles.superAdmin ||
            useSystemMailClient ? 'Send Invite' : 'Create User'
          }}</span>
      </div>
    </app-primary-button>
  </div>

</div>
